import {Component, Input, OnChanges, SimpleChanges} from "@angular/core";
import {isDefined} from "../../utils/utils";
import {BrowserSessionApi} from '../../api/rest/browserSession.restapi';

type SessionId = string;
type ElementId = string;

interface SeleniumCommand {
    getDescription(): string;
}

class SendKeysAction implements SeleniumCommand {
    constructor(public readonly texts: string[], public readonly sessionId: SessionId, public readonly elementId: ElementId) {}

    static fromJson(actionData: any, sessionContext: any): SendKeysAction {
        return new SendKeysAction(actionData['texts'], actionData['sessionId'], actionData['elementId']);
    }

    getDescription(): string {
        return "Send text \"" + this.texts.join(", ") + "\" to element " + this.elementId;
    }
}

@Component({
    selector: 'wm-selenium-action-artifact',
    templateUrl: './selenium-action-artifact.component.html',
    styleUrls: ['./selenium-action-artifact.component.less']
})
export class SeleniumActionArtifactComponent implements OnChanges {

    @Input()
    artifactData: any;

    @Input()
    summary?: boolean = false;

    description?: string;

    commandName: string;

    isResult = false;

    errorMsg?: string;

    resultData: any;

    actionData: any;

    constructor(private browserSessionApi: BrowserSessionApi) {}

    ngOnChanges(changes: SimpleChanges) {
        this.isResult = this.artifactData.artifactType === 'Action.ActionFinish';

        if (this.artifactData?.data) {
            if (this.isResult && this.artifactData.data.error) {
                this.errorMsg = this.artifactData.data.error.errorMessage;
            }
            if (!this.isError()) {
                this.resultData = this.artifactData.data.result;
            }
            this.commandName = !this.isResult ? this.artifactData.data['type'] || 'unknown' : undefined;
            this.actionData = !this.isResult ? this.artifactData.data : undefined;
            this.description = this.makeDescription(this.artifactData);
        } else {
            this.errorMsg = undefined;
            this.commandName = 'unknown command';
            this.actionData = undefined;
            this.description = undefined;
        }
    }

    isError(): boolean {
        return isDefined(this.errorMsg);
    }

    objectWithoutTypeField(obj: any): any {
        let result ={...obj};
        result['type'] = undefined;
        return result;
    }

    private actionFactories: Map<string, (_1: any, _2: any) => SeleniumCommand> = new Map([
        ['ElementSendKeys', SendKeysAction.fromJson],
    ]);

    makeDescription(actionArtifact: any): string {
        if (actionArtifact?.optJsonContent) {
            let actionData = actionArtifact.optJsonContent;
            if (isDefined(actionData)) {
                let factory = this.actionFactories.get(actionData['type']);
                if (!isDefined(factory)) {
                    return actionData['type'];
                }
                let actionInstance = factory(actionData, undefined);
                return actionInstance.getDescription();
            } else {
                return "result";
            }
        } else {
            return "unknown";
        }
    }

}
